import React, { Component } from 'react';
import  { Divider }  from 'semantic-ui-react';

class Donations extends Component {

    render() {
      return (
        <div className="Footer">
            <p><b>IOTA Address Donations</b>: TSABRWZQKMTVDBFBFVQUYQLEOBEONIPLCEVRZEPUWR9HVZYTEZBPLEBFZFVILCYVNWZCPLFBEDGEMEYVBDOQWAINYW</p>
            <Divider />
        </div>
      );
    }
  }

export default Donations;


// WEBPACK FOOTER //
// ./src/components/Donations.js